var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSabbath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.308 6.831s-1.599-2.525-.374-4.272C5.158.813 4.954 0 4.954 0s2.568 2.543.392 6.814c-.018-2.458-.612-2.34-.612-2.34s-.596-.22-.426 2.357",
    transform: "translate(.312 .361)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.493 12.162l-.15-4.76s-.613.154-1.492.165V5.534h-.155v2.03c-.45-.003-.957-.042-1.491-.163-.01-.2-.103 2.983-.154 4.761h3.442z",
    transform: "translate(.312 .361)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F54",
    d: "M3.137 23.197c-.304.358-.49.817-.503 1.32C1.11 25.282.05 26.83 0 28.637h9.544c-.05-1.806-1.11-3.355-2.636-4.12-.012-.503-.198-.962-.502-1.32V16.31c.265-.312.44-.7.49-1.128.786-.613 1.303-1.554 1.333-2.62H1.314c.03 1.066.547 2.007 1.333 2.62.05.427.225.816.49 1.128v6.887z",
    transform: "translate(.312 .361)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.464 6.831s-1.598-2.525-.373-4.272C16.315.813 16.11 0 16.11 0s2.568 2.543.39 6.814c-.016-2.458-.611-2.34-.611-2.34s-.596-.22-.426 2.357",
    transform: "translate(.312 .361)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.649 12.162l-.15-4.76s-.613.154-1.492.165V5.534h-.154v2.03c-.452-.003-.958-.042-1.493-.163-.009-.2-.102 2.983-.153 4.761h3.442z",
    transform: "translate(.312 .361)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F54",
    d: "M14.293 23.197c-.304.358-.49.817-.502 1.32-1.525.765-2.585 2.313-2.635 4.12H20.7c-.05-1.806-1.11-3.355-2.635-4.12-.013-.503-.2-.962-.502-1.32V16.31c.264-.312.44-.7.49-1.128.786-.613 1.302-1.554 1.332-2.62H12.47c.03 1.066.547 2.007 1.333 2.62.05.427.225.816.49 1.128v6.887z",
    transform: "translate(.312 .361)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabbath);
export default __webpack_public_path__ + "static/media/Sabbath.60161df5962502cb4dca1203647f1995.svg";
export { ForwardRef as ReactComponent };